import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { LastVisitedCompanyService } from '@shared/services/last-visited-company.service';
import { catchError, map, of, switchMap } from 'rxjs';
import { AuthService } from '../auth.service';

export const connectLastCompanyGuard: CanActivateFn = () => {
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);
  const authService = inject(AuthService);
  const lastVisitedCompany = inject(LastVisitedCompanyService);

  if (!isPlatformBrowser(platformId)) return router.parseUrl('/meu-perfil');

  return authService.check().pipe(
    catchError(() => of(router.parseUrl('/offline'))),
    switchMap((authenticated: boolean | UrlTree) => {
      if (authenticated instanceof UrlTree) return of(authenticated);
      if (!authenticated) return of(router.parseUrl('/sign-in'));

      return lastVisitedCompany.resolve().pipe(
        map((slug) => (slug ? lastVisitedCompany.euUrlTree(router, slug) : router.parseUrl('/meu-perfil')))
      );
    })
  );
};

export const lastCompanyRedirectGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);
  const lastVisitedCompany = inject(LastVisitedCompanyService);
  const view = route.data['lastCompanyView'] === 'bookings' ? 'agendamentos' : undefined;

  if (!isPlatformBrowser(platformId)) return true;

  return lastVisitedCompany.resolve().pipe(
    map((slug) => (slug ? lastVisitedCompany.euUrlTree(router, slug, view) : true))
  );
};
